import React, { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';
type ScarcityBarProps = {
  tone?: 'light' | 'dark';
  className?: string;
};
export function ScarcityBar({
  tone = 'light',
  className = ''
}: ScarcityBarProps) {
  const [spots, setSpots] = useState(17);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSpots(prev => prev <= 6 ? 17 : prev - 1);
    }, 24000);
    return () => window.clearInterval(id);
  }, []);
  const claimed = 500 - spots;
  const percent = Math.min(99, Math.round(claimed / 500 * 100));
  const isDark = tone === 'dark';
  return <div className={`w-full rounded-2xl border p-4 ${isDark ? 'border-white/20 bg-white/10' : 'border-rose/25 bg-rose-mist'} ${className}`} data-id="element-64" data-mp="226lhd1rt6mn0">
      <div className="flex items-start gap-2" data-id="element-65" data-mp="276zrcpcz06no">
        <FlameIcon className={`mt-0.5 h-4 w-4 shrink-0 ${isDark ? 'text-rose-light' : 'text-rose'}`} aria-hidden="true" data-id="element-66" data-mp="fqke6lv8hep" />
        <p className={`text-[13px] font-bold leading-snug ${isDark ? 'text-white' : 'text-navy'}`} data-id="element-67" data-mp="5bfnul10aiga">
          Only <span className={isDark ? 'text-rose-light' : 'text-rose'} data-id="element-68" data-mp="2zlji4gjmotyl">{spots} spots</span> left
          at the $27 launch price
        </p>
      </div>

      <div className={`mt-3 h-3 w-full overflow-hidden rounded-full ${isDark ? 'bg-white/20' : 'bg-white'}`} role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={percent} aria-label="Launch price spots claimed" data-id="element-69" data-mp="3dbwmk8xb9qj6">
        <div className="h-full rounded-full bg-rose transition-[width] duration-500 ease-out" style={{
        width: `${percent}%`
      }} data-id="element-70" data-mp="2go8jmy5tm4k7" />
      </div>

      <p className={`mt-2 text-[11.5px] font-semibold ${isDark ? 'text-white/70' : 'text-navy/60'}`} data-id="element-71" data-mp="2pm2e03k0yo4q">
        {percent}% claimed · {claimed} of 500 launch spots taken
      </p>
    </div>;
}